// extracted by css-extract-rspack-plugin
export default {"cls1":"AuthorHeader-cls1_qg0","cls2":"AuthorHeader-cls2_vZ1 AuthorHeader-cls1_qg0"};